module.exports = __webpack_public_path__ + "static/media/English_British Emma BG-04.f6390e09.png";